import React, { useCallback } from 'react';
import type { FC } from 'react';
import { useTranslation } from '@wix/cli-i18n';
import type { SelectOption } from '@wix/cli-ui-kit';
import { SelectInput } from '@wix/cli-ui-kit';
import type { Site } from '@wix/site-list-client';
import { useSiteSelectorBi } from './bi.js';

interface Props {
  onSubmit: (site: Site) => void;
  sites: Site[];
}

export const SiteListSelect: FC<Props> = ({ onSubmit, sites }) => {
  const { t } = useTranslation();
  const bi = useSiteSelectorBi();

  const handleSubmit = useCallback(
    (option: SelectOption<Site>) => {
      bi.cliFlowStepAnswered({
        question: t('site_list_select.label'),
        answer: option.title,
      });
      onSubmit(option.value);
    },
    [bi, onSubmit, t]
  );

  return (
    <SelectInput<Site>
      label={t('site_list_select.label')}
      options={sites.map((site) => ({
        key: site.id,
        title: site.displayName,
        description: site.viewUrl,
        value: site,
      }))}
      onSubmit={handleSubmit}
    />
  );
};
